import React from 'react';
import './style.css';

const MapCard = ({ title, address }) => {
  return (
    <div className="map-card">
        <h2 className="section-title">Localização do laboratorio</h2>
      <img src="/dashboard-images/mapa.png" alt="Mapa da localização" className="map-card-image" />
      <div className="map-card-content">
        <h3 className="map-card-title">{title}</h3>
        <p className="map-card-description">{address}</p>
      </div>
    </div>
  );
};

export default MapCard;
